/**
 * Build LinkTo's model list without discarding falsy serialized IDs.
 * @param model Persisted ID or serialized segment; null and undefined mean no segment.
 * @returns One segment when supplied, otherwise an empty list.
 */
export function routeModels(model?: string | number | null) {
  return model === undefined || model === null ? [] : [model];
}
